import { quarterDates, dateDiffInDays } from '@/utils/date';
import { DatePicker } from '@tencent/spaui';
import React from 'react';
import cookie from '@/utils/cookie';
import _ from 'lodash';

export const SYSTEM_AGENCY_ID = 1000;

// 校验成功
export const CHECK_STATUS_SUCCESS = 'SUCCESS';
// 校验失败
export const CHECK_STATUS_FAILED = 'FAILED';
// 校验中
export const CHECK_STATUS_ONGOING = 'ONGOING';
// 待校验
export const CHECK_STATUS_TOBE = 'TOBE';

// 不创建
export const SEAT_OPTION_NOT_CREATE = 0;
// 现在创建
export const SEAT_OPTION_NOW_CREATE = 1;
// 已创建
export const SEAT_OPTION_ALREADY_CREATE = 2;

// 初级
export const ROLE_LEVEL_PRIMARY = 1;
// 中级
export const ROLE_LEVEL_MIDDLE = 2;
// 未认证
export const ROLE_LEVEL_NOT_CERTIFICATE = 3;

// 选项：Yes
export const OPTION_YES = 1;
// 选项：No
export const OPTION_NO = 0;

export const SECRET_FIELD_REPLACER = '********';

export const RANGE_DEFAULT_SHORTCUTS = [
  { startRelativeDate: 0, endRelativeDate: 0, label: '今天' },
  { startRelativeDate: -1, endRelativeDate: -1, label: '昨天' },
  { startRelativeDate: -6, endRelativeDate: 0, label: '最近7天' },
  { startRelativeDate: -29, endRelativeDate: 0, label: '最近30天' },
  { startRelativeDate: -89, endRelativeDate: 0, label: '最近90天' },
  // 设置了dynamicDate为true 会在选择了startDate但endDate没选时生效，并以startDate为相对日期
  {
    startRelativeDate: 0,
    endRelativeDate: 6,
    dynamicDate: true,
    label: '往后7天',
  },
  {
    startRelativeDate: 0,
    endRelativeDate: 29,
    dynamicDate: true,
    label: '往后30天',
  },
  {
    startRelativeDate: 0,
    endRelativeDate: 89,
    dynamicDate: true,
    label: '往后90天',
  },
];

export const pageSizeList = [10, 20, 30]; // 暂时用来解决无页面级别权限 页面白页的问题

export const TIME = 10; // 下载 十秒限制

// 一些数量上的配置
export const COUNTLIMIT = {
  pagesize: 10, // 报表页面默认数量
  commentCount: 32, // 备注最长长度
};

const curDate = new Date();
const curQuarter = quarterDates();
const startQuarterDay = curQuarter[0];
const endQuarterDay = curQuarter[1];
const diffStart = dateDiffInDays(curDate, startQuarterDay);
const diffEnd = dateDiffInDays(curDate, endQuarterDay);

// 日期
export const DATESHORTCUTS = [
  'today',
  'yesterday',
  'past7days',
  'past30days',
  'thismonth',
  'lastmonth',
  {
    label: '本季度',
    start: diffStart,
    end: diffEnd,
    type: 'days',
  },
];

// 默认两年
export const defaultDateRange = function (y) {
  if (!y) {
    y = 2;
  }
  const date = new Date();
  let year = date.getFullYear(); // 获取当前年份(2位)
  if (year <= y) {
    year = year - y + year;
  } else {
    year = year - y;
  }
  const month = date.getMonth() + 1; // 获取当前月
  const day = date.getDate(); // 获取当前日
  return `${year}-${month}-${day}`;
};

export const adPlatformLabelDef = {
  1: 'UID',
  2: 'SPID',
};

// 服务商审核状态定义
export const agencyAccountStatusDef = {
  CUSTOMERSTATUS_NORMAL: 1,
  CUSTOMERSTATUS_PENDING: 2,
  CUSTOMERSTATUS_DENIED: 3,
  CUSTOMERSTATUS_FROZEN: 4,
  CUSTOMERSTATUS_TOBE_ACCEPTED: 5,
  CUSTOMERSTATUS_TOBE_ACTIVATED: 6,
  CUSTOMERSTATUS_SUSPEND: 7,
  CUSTOMERSTATUS_MATERIAL_PREPARED: 8,
  CUSTOMERSTATUS_DELETED: 9,
  CUSTOMERSTATUS_FREEZE: 10,
  CUSTOMERSTATUS_UNREGISTERED: 11,
  CUSTOMERSTATUS_PENDINGREVIEW: 12,
};

// 代理商账户状态文案
export const agencyAccountStatusLabelMap = {
  1: '审核通过',
  2: '待审核',
  3: '审核不通过',
  4: '封停',
  5: '待接受',
  6: '待激活',
  7: '暂停',
  8: '广告主资料准备',
  9: '删除',
  10: '冻结',
  11: '未注册',
  12: '待重新审核',
};

// 职位：销售
export const POSITION_SALE = 1;
export const POSITION_OPERATION = 2;

// TODO: 可删除
export const placeholderNames = {
  1: '请输入广告主名称',
  2: '多个请用英文逗号间隔',
  3: '多个请用英文逗号间隔',
  4: '请输入原始ID',
};

// 服务商支持BM
export const AGENCY_TYPE = {
  SUPPORT_BM: 1,
  NO_BM: 2,
};

export const agencyTypeConfig = [
  {
    value: AGENCY_TYPE.SUPPORT_BM,
    children: '支持BM',
  },
  {
    value: AGENCY_TYPE.NO_BM,
    children: '无BM的服务商',
  },
];

// 所有用户确认的list
export const USER_CONFIRMS = {
  SALE_MANAGE_AGREEMENT: 'SALE_MANAGE_AGREEMENT',
};

// 渠道导入标签对应ID
export const CHANNEL_IMPORT = 10152;

// 账户类型
export const ACCOUNT_TYPE = {
  default: 2,
  direct: 13,
  tech: 21,
};

export const AD_PLATFORM_TYPE = {
  GDT: 1,
  MP: 2,
  CPS: 3,
};

// 平台名称
export const AD_PLATFORM_TYPE_NAME = {
  ADQ: 'ADQ广告',
  MP: 'MP广告',
  CPS: 'CPS商品广告',
  default: 'default',
};

// 平台过滤规则
export const AD_PLATFORM_TYPE_RULE = {
  default: (v) => v,
  // [AD_PLATFORM_TYPE_NAME.ADQ]: (v) => v.ad_platform_type === AD_PLATFORM_TYPE.GDT && !v.is_cps,
  [AD_PLATFORM_TYPE_NAME.ADQ]: (v, options) => ((v.ad_platform_type === AD_PLATFORM_TYPE.GDT && !v.is_cps) || (options?.isMergeMp && v.ad_platform_type === AD_PLATFORM_TYPE.MP)),
  [AD_PLATFORM_TYPE_NAME.MP]: (v) => v.ad_platform_type === AD_PLATFORM_TYPE.MP,
  [AD_PLATFORM_TYPE_NAME.CPS]: (v) => v.ad_platform_type === AD_PLATFORM_TYPE.GDT && v.is_cps,
};

// 服务商cookie名
export const AGENCY_UID_COOKIE_NAME = {
  default: 'agency_uid',
  [AD_PLATFORM_TYPE_NAME.ADQ]: 'agency_uid_adq',
  [AD_PLATFORM_TYPE_NAME.MP]: 'agency_uid_mp',
  [AD_PLATFORM_TYPE_NAME.CPS]: 'agency_uid_cps',
};

// 活动管理参与状态
export const PARTICIPATION_STATUS = {
  1: '报名',
  2: '出席',
};

// 短信包信息发送状态
export const MESSAGE_STATUS = {
  1: '正在发送',
  2: '已发送',
};
// relation_type上报
export const LEAD = 'lead'; // 线索管理
export const POTENTIAL = 'potential'; // 商机管理
export const ORDER = 'order'; // 订单管理
export const SEAS_LEAD = 'seasLead'; // 公海池-线索
export const SEAS_POTENTIAL = 'seasPotential'; // 公海池-商机
export const OUTSIDE = 'outside'; // 外勤管理
export const CUSTOMER = 'customer'; // 客户管理
export const CHANNEL = 'channel'; // 渠道订单
export const DISTRIBUTE = 'distribute'; // 分发池

export const FLAGS = {
  GUIDE: 'ams_new_guide_20201118',
  GUIDE_TIP_STORAGE: {
    GLOBAL_KEY: 'ams_guide_tip_show',
    OPRATION_LOG: 'operation_log_20210111',
    MARKET_SERVCIE: 'market_service_202104',
    MERGE_USER_ID: 'merge_user_id_202102',
    ADMASTER: 'admaster_202104',
    SUB_MENU_KEY: 'ams_sub_menu_guide_20230530',
  },
  WARN_DIALOG_STORAGE_COMBINED_KEY: 'ams_warn_dialog_storage',
  AMS_HOME_DIALOG_STORAGE_KEY: 'ams_home_dialog',
  AREA: 'custom_column_20211229',
  CUSTOM_COLUMN: {
    TIP_KEY_PREFIX: 'ams_custom_column_tip_show',
    COLUMNS_STORAGE_KEY: 'ams_custom_column_storage_key',
  },
  USER_CUSTOM_CONFIG: 'ams_user_custom_config', // 用户自定义配置
  LOGIN_INFO_CACHE_KEY: {
    GLOBAL_KEY: 'ams_user_info',
    ACCOUNT_INFO_KEY: 'account_info',
  },
};

export const REACT_APP_PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL;

export const ROLE_LIST_SALE = '115';

export const IS_REGIST_MOBILE = 'is_regist_mobile';

// 修改日志操作类型
export const CHANGE_LOG_TYPE = {
  2: '修改',
};

// 跟进记录添加批注
export const ACTION_RECORD_TYPE = {
  ACTION_TYPE_ADD_ANNOTATION: 31,
};

// 微信附近推销售状态
export const WECHAT_SALES_STATUS_MAP = {
  WECHAT_SALES_STATUS_UNINITIALIZED: 0, // 尚未创建
  WECHAT_SALES_STATUS_VALID: 1, // 有效
  WECHAT_SALES_STATUS_INVALID: 2, // 无效
};

// 附近推开户状态
export const NEARBY_PUSH_STATUS = {
  1: '已开户',
};

// 附近推购买套餐计划状态
export const PACKAGE_PLAN_STATUS = {
  TO_LOCK_FLOW: '待锁定',
  LOCK_FLOW_FAIL: '排期失败',
  LOCK_FLOW_ING: '等待排期结果',
  ADSTATUS_PENDING: '审核中',
  ADSTATUS_DENIED: '未通过',
  ADSTATUS_READY: '待投放',
  ADSTATUS_NORMAL: '投放中',
  ADSTATUS_SUSPEND: '暂停投放',
  ADSTATUS_FINISH: '投放结束',
  ADSTATUS_CANCEL: '取消投放',
  COOPERATION_PENDING: '合作确认中',
  COOPERATION_NOT_OK: '合作未达成',
  ADSTATUS_UNKNOWN: '异常状态',
  HOST_ARTICLE_PREPARING: '文章编辑中',
  HOST_ARTICLE_PENDING: '文章待确认',
  ADSTATUS_CREATING: '创建中',
  LOCK_FLOW_SUC: '公众号底部的锁定排期',
  ADSTATUS_PAID_SUC: '已支付',
  ADSTATUS_SYSTEM_SUSPEND: '系统暂停',
  ADSTATUS_REFUND: '已失效',
};

// 附近推退款流水状态
export const REFUND_FLOW_STATUS = {
  0: '审批中',
  1: '通过',
  2: '驳回',
};

export const unlimitedDateProps = {
  longestRange: 365000,
  optionalStartDate: '2000-01-01',
  optionalEndDate: '2999-01-01',
  endDateCanBeUnlimited: true,
  unlimitedDateValue: '2999-12-31',
  unlimitedDateValueLabel: '无限日期',
};

export const debug = location.search.indexOf('__debug__') !== -1 || cookie.get('__debug__');

// 销售规则,开户单规则
export const OPENING_RULE = [
  {
    label: '未知',
    key: 'UNKOWN_OPENING_PROCESS', // 未知
    value: 0,
  },
  {
    label: '销售提交开户资料-分配开户员-开户专员开户（步骤：1.销售填写基础信息；2.管理员分配开户专员；3.开户专员填写补充投放信息并开户）',
    key: 'OPEN_WITH_SUBMIT_ACCOUNT_OPENING_INFORMATION', // 销售提交开户资料-分配-开户人
    value: 1,
  },
  {
    label: '销售自行开户（步骤：1.销售填写客户基础信息，开户信息并开户）',
    key: 'OPEN_YOUR_OWN_ACCOUNT', // 销售自行开户
    value: 2,
  },
  {
    label: '销售提交开户需求-分配开户员-开户专员开户（仅提交开户申请，基础信息及投放信息由开户专员填写）',
    key: 'OPEN_JUST_SUBMIT_ACCOUNT_APPLICATION', // 销售仅提交开户申请-分配-开户人填写开户资料并开户
    value: 3,
  },
];

// 活动更新提醒
export const ACTIVITY_UPDATE_REMIND = {
  unremind: 0,
  remind: 1,
};

export const PAGE_INFO_MAP = {
  advertising: {
    page1: '客户',
    page2: '账户列表',
    page3: 'ADQ广告',
  },
  wechatlist: {
    page1: '客户',
    page2: '账户列表',
    page3: 'MP广告',
  },
  cpslist: {
    page1: '客户',
    page2: '账户列表',
    page3: 'CPS商品广告',
  },
  accountlist: {
    page1: '客户',
    page2: '投放广告',
    page3: 'ADQ广告',
  },
  wechatrpt: {
    page1: '客户',
    page2: '投放广告',
    page3: 'MP广告',
  },
};

// 呼叫中心供应商
export const CALL_CENTER_VENDOR = {
  CALL_CENTER_VENDOR_UNKNOWN: {
    label: '未知',
    key: 'CALL_CENTER_VENDOR_UNKNOWN',
  }, // 0
  CALL_CENTER_VENDOR_CHANNELSOFT: {
    label: '青牛',
    key: 'CALL_CENTER_VENDOR_CHANNELSOFT',
  }, // 1
  CALL_CENTER_VENDOR_CTICLOUD: {
    label: '天润',
    key: 'CALL_CENTER_VENDOR_CTICLOUD',
  }, // 2
  CALL_CENTER_VENDOR_QIDIAN: {
    label: '企点',
    key: 'CALL_CENTER_VENDOR_QIDIAN',
  }, // 3
  CALL_CENTER_VENDOR_TCCC: {
    label: 'TCCC',
    key: 'CALL_CENTER_VENDOR_TCCC',
  }, // 4
};
export const callCenterConfig = window.pageProps?.callCenter?.map((v) => {
  return {
    ...v,
    value: v.vendor,
    label: CALL_CENTER_VENDOR[v.vendor].label,
  };
});

// 线索清洗状态
export const CLEANING_STATUS = [
  {
    value: 'CLEANING_STATUS_VALID',
    label: '合格',
    des: '符合广告投放条件（客户行业准入；执照/资质齐全（或近三个月内可以办理齐全）；无人对接）',
  },
  {
    value: 'CLEANING_STATUS_CONTINUABLE',
    label: '继续跟进',
    des: '需再次跟进清洗',
    filter: true,
  },
  {
    value: 'CLEANING_STATUS_TEMPNOTVALID',
    label: '暂不合格',
    des: '暂不符合广告投放条件，但后续可加温清洗',
  },
  {
    value: 'CLEANING_STATUS_INVALID',
    label: '不合格',
    des: '不符合广告投放条件',
  },
];

// 线索分配规则类型
export const leadAssignTypeMap = [
  {
    label: '外部导入的线索自动分配给',
    value: 'LEAD_ASSIGN_TYPE_SIMPLE', // 简单规则，只兜底
    key: 0,
  },
  {
    label: '设置自动分配规则（外部导入的线索将根据规则，自动分配给指定人）',
    value: 'LEAD_ASSIGN_TYPE_CONDITION', // 条件规则，
    key: 1,
  },
];

// 商机分配规则
export const potentialAssignTypeMap = [
  {
    label: '转商机时商机在本人名下',
    value: 'LEAD_ASSIGN_TYPE_SIMPLE', // 简单规则，只兜底
    key: 0,
  },
  {
    label: '转商机时根据规则分配给指定销售（线索清洗员一键转商机，系统根据规则分配商机）',
    value: 'LEAD_ASSIGN_TYPE_CONDITION', // 条件规则，
    key: 1,
  },
];

// 商机接收规则
export const potentialAcceptTypeMap = [
  {
    label: '外部导入的商机自动分配给',
    value: 'LEAD_ASSIGN_TYPE_SIMPLE', // 简单规则，只兜底
    key: 0,
  },
  {
    label: '设置自动分配规则（外部导入的线索将根据规则，自动分配给指定人）',
    value: 'LEAD_ASSIGN_TYPE_CONDITION', // 条件规则，
    key: 1,
  },
];

// 接收组
export const dispatcherReceiverTypeMap = {
  DISPATCHER_RECEIVER_TYPE_TEAM: 0, // 团队
  DISPATCHER_RECEIVER_TYPE_MEMBERS: 1, // 个人
  DISPATCHER_RECEIVER_TYPE_ORIGINAL_FOLLOWER: 2, // 原跟进人
};

// 分配机制
export const dispatcherDistributionType = {
  DISPATCHER_DISTRIBUTION_TYPE_BALANCE: 0, // 平均分配
  DISPATCHER_DISTRIBUTION_TYPE_WITH_UPPER_BOUND: 1, // 平均分配，单每个员工处理数有上限
};

// 重置方式
export const resetDurationType = {
  DISPATCHER_RESET_DURATION_PER_DAY: '天',
  DISPATCHER_RESET_DURATION_PER_HOUR: '小时',
  DISPATCHER_RESET_DURATION_PER_MONTH: '月',
};

export const isProd = process.env.REACT_APP_ENV === 'production';

export const isDebug = location.search.indexOf('__debug__') !== -1 || cookie.get('__debug__');

// 线索当前状态(0: 未知, 1: 线索, 2: 商机, 3: 订单)
export const leadStatusMap = {
  1: 'leads',
  2: 'potentials',
  3: 'orders',
};

export const PREFIX_FORMPAGE_CLASSNAME = 'crm-form-page';

// MP测客保状态
export const SMB_FLAG = {
  0: '未保护',
  1: '申请保护',
  2: '拒绝保护',
  3: '保护中',
};

export const MP_APPLY_STATUS = {
  0: '未审核',
  1: '通过',
  2: '不通过',
};

// 账户审核状态
export const ACCOUNT_STATUS = {
  // 0: "未知",
  1: '通过',
  3: '拒绝',
};

// 默认可选开始相对时间
export const OPTIONAL_START_RELATIVE_DAYS = 365 * 2;

export const QiDianCallInTraceMap = {
  CALLING_STATUS_IN_AGENT_CONNECT: {
    CallStatus: 3,
    CallDirection: 1,
  }, // "呼入接通"
};

export const DIAL_DIRECTION = {
  DIAL_DIRECTION_IN: '呼入',
  DIAL_DIRECTION_OUT: '呼出',
};

// 智能外呼结果
export const DIAL_OUT_RESULT_TYPE = {
  DIAL_OUT_RESULT_UNKNOWN: '未知',
  DIAL_OUT_RESULT_HIGH_INTENTION: '高意向',
  DIAL_OUT_RESULT_LOW_INTENTION: '低意向',
  DIAL_OUT_RESULT_ON_INTENTION: '无意向',
  DIAL_OUT_RESULT_NO_REPLY: '无回复',
  DIAL_OUT_RESULT_NO_REACH: '未触达',
  DIAL_OUT_RESULT_INVALID_NUMBER: '无效号码',
  DIAL_OUT_RESULT_HANG_UP: '挂断',
};

// 外呼方向
export const dialDirectionMap = [{
  label: '全部',
  value: 0,
},
..._.map(_.keys(DIAL_DIRECTION), (v) => {
  return {
    label: DIAL_DIRECTION[v],
    value: v,
  };
}),
];

// 通话时长
export const DATA_TALK_DURATION = [
  {
    label: '低于60s',
    value: 1,
  },
  {
    label: '60（含）-120s',
    value: 2,
  },
  {
    label: '120s（含）-180s',
    value: 3,
  },
  {
    label: '180s（含）-300s',
    value: 4,
  },
  {
    label: '超过300s（含）',
    value: 5,
  },
];
// 未接通原因
export const DATA_CALL_END_REASON = [
  {
    label: '接听成功',
    value: '0',
  },
  {
    label: '拒接',
    value: '1',
  },
  {
    label: '无人接听',
    value: '2',
  },
  {
    label: '关机',
    value: '3',
  },
  {
    label: '停机',
    value: '4',
  },
  {
    label: '正在通话',
    value: '5',
  },
  {
    label: '暂时无法接通',
    value: '6',
  },
  {
    label: '空号',
    value: '7',
  },
  {
    label: '坐席sdk未登录',
    value: '8',
  },
  {
    label: '呼叫等待',
    value: '9',
  },
  {
    label: '主叫挂断（被叫振铃后）',
    value: '10',
  },
  {
    label: '主叫取消（被叫振铃前）',
    value: '11',
  },
  // 以下为tccc 展示逻辑
  {
    label: 'TCCC_系统错误',
    value: 'error',
  },
  {
    label: 'TCCC_正常结束',
    value: 'ok',
  },
  {
    label: 'TCCC_未接通',
    value: 'unconnected',
  },
  {
    label: 'TCCC_呼入黑名单',
    value: 'blackList',
  },
  {
    label: 'TCCC_IVR期间用户放弃',
    value: 'ivrGiveUp',
  },
  {
    label: 'TCCC_会话排队期间用户放弃',
    value: 'waitingGiveUp',
  },
  {
    label: 'TCCC_会话振铃期间用户放弃',
    value: 'ringingGiveUp',
  },
  {
    label: 'TCCC_无座席在线',
    value: 'noSeatOnline',
  },
  {
    label: 'TCCC_非工作时间',
    value: 'notWorkTime',
  },
  {
    label: 'TCCC_IVR后直接结束',
    value: 'ivrEnd',
  },
  {
    label: 'TCCC_被叫因高风险受限',
    value: 'restrictedCallee',
  },
  {
    label: 'TCCC_超频',
    value: 'tooManyRequest',
  },
  {
    label: 'TCCC_外呼盲区',
    value: 'restrictedArea',
  },
  {
    label: 'TCCC_外呼时间限制',
    value: 'restrictedTime',
  },
  {
    label: 'TCCC_未知状态',
    value: 'unknown',
  },
  {
    label: 'TCCC_未接听',
    value: 'notAnswer',
  },
  {
    label: 'TCCC_拒接挂断',
    value: 'userReject',
  },
  {
    label: 'TCCC_关机',
    value: 'powerOff',
  },
  {
    label: 'TCCC_空号',
    value: 'numberNotExist',
  },
  {
    label: 'TCCC_通话中',
    value: 'busy',
  },
  {
    label: 'TCCC_欠费',
    value: 'outOfCredit',
  },
  {
    label: 'TCCC_运营商线路异常',
    value: 'operatorError',
  },
  {
    label: 'TCCC_主叫取消',
    value: 'callerCancel',
  },
  {
    label: 'TCCC_不在服务区',
    value: 'notInService',
  },
  {
    label: 'TCCC_客户端错误',
    value: 'clientError',
  },

  // 以下内容按照TCCC的定义，需要补充label
  {
    label: 'TCCC_运营商拦截',
    value: 'carrierBlocked',
  },

  {
    label: 'TCCC_提示来电提醒',
    value: 'callReminder',
  },

  {
    label: 'TCCC_被叫号码无效',
    value: 'numberInvalid',
  },

  {
    label: 'TCCC_提示呼叫受限',
    value: 'callRestricted',
  },

  {
    label: 'TCCC_被叫黑名单受限',
    value: 'calleeRestricted',
  },

  {
    label: 'TCCC_被叫区域受限',
    value: 'areaRestricted',
  },

  {
    label: 'TCCC_提示呼叫转移',
    value: 'promptCallForwarding',
  },
  {
    label: 'TCCC_振铃中主叫取消',
    value: 'callerCancelWhileRing',
  },
  {
    label: 'TCCC_未振铃被叫号码异常',
    value: 'callerCancelWithoutRing',
  },
  {
    label: 'TCCC_VoIP用户呼叫冲突终止',
    value: 'callConflict',
  },
  {
    label: 'TCCC_VoIP用户客户端超时',
    value: 'clientTimeout',
  },
  {
    label: 'TCCC_VoIP用户客户端错误',
    value: 'voipClientError',
  },
];

// 满意度类型
export const SATISFACTION_TYPE = [
  {
    desc: '未发起',
    value: '0',
    valueData: [0],
  },
  {
    desc: '二级满意度',
    value: '2',
    valueData: [1, 2],
    options: [
      {
        desc: '不满意',
        value: '2-1',
      },
      {
        desc: '满意',
        value: '2-2',
      },
    ],
  },
  {
    desc: '三级满意度',
    value: '3',
    valueData: [1, 2, 3],
    options: [
      {
        desc: '不满意',
        value: '3-1',
      },
      {
        desc: '一般',
        value: '3-2',
      },
      {
        desc: '满意',
        value: '3-3',
      },
    ],
  },
  {
    desc: '四级满意度',
    value: '4',
    valueData: [1, 2, 3, 4],
    options: [
      {
        desc: '非常不满意',
        value: '4-1',
      },
      {
        desc: '不太满意',
        value: '4-2',
      },
      {
        desc: '比较满意',
        value: '4-3',
      },
      {
        desc: '非常满意',
        value: '4-4',
      },
    ],
  },
  {
    desc: '五级满意度',
    value: '5',
    valueData: [1, 2, 3, 4, 5],
    options: [
      {
        desc: '非常不满意',
        value: '5-1',
      },
      {
        desc: '不太满意',
        value: '5-2',
      },
      {
        desc: '一般',
        value: '5-3',
      },
      {
        desc: '比较满意',
        value: '5-4',
      },
      {
        desc: '非常满意',
        value: '5-5',
      },
    ],
  },
];

// 根据线索状态确定清洗线索按钮展示与否
export const cleanLeadPerms = ['CLEANING_STATUS_PENDING', 'CLEANING_STATUS_TEMPNOTVALID', 'CLEANING_STATUS_CONTINUABLE'];

// 流程状态
export const PROGRESS_STATUS = {
  PROGRESS_STATUS_LEAD: 'PROGRESS_STATUS_LEAD',
  PROGRESS_STATUS_POTENTIAL: 'PROGRESS_STATUS_POTENTIAL',
  PROGRESS_STATUS_ORDER: 'PROGRESS_STATUS_ORDER',
};

// 呼叫限制
export const DIAL_OUT_RULE_MAP = {
  0: '已超出',
  1: '未超出',
};

// 企微客户好友状态
export const WECHAT_CUSTOMER_STATUS = {
  VALID: 0, // 有效
  INVALID: 1, // 无效
};

// lg呼入一级标签
export const lgCallLabelMap = {
  direct_customer: 'DIAL_IN_FIRST_DIRECT_CUSTOMER', // 直销客户
  agency_sub_customer: 'DIAL_IN_FIRST_AGENCY_SUB_CUSTOMER', // 服务商子客
  complaint_tag: 'DIAL_IN_FIRST_COMPLAINT_TAG', // '投诉'
  exist_agency: 'DIAL_IN_FIRST_EXIST_AGENCY', // '现有服务商'
  non_advertiser_consulting: 'DIAL_IN_FIRST_NON_ADVERTISER_CONSULTING', // '非广告投放咨询'
  other_tag: 'DIAL_IN_FIRST_OTHER_TAG', // '其他'
  self_support_customer: 'DIAL_IN_FIRST_SELF_SUPPORT_CUSTOMER', // '自助客户'
};

// 新建编辑线索来源（腾讯导入新线索 or 自建）
export const leadCreateSourceType = ['SYSTEM_SOURCE_TYPE_TENCENT_IMPORT_LEAD', 'SYSTEM_SOURCE_TYPE_AGENCY_CREATED'];

// 转商机默认商机状态， 商机原因
export const toPotentialDefaultConfig = {
  potentialStatus: 'POTENTIAL_STATUS_NEW', // 待处理
  transactionProbability: 0,
  potentialSecondSeasonType: 'POTENTIAL_SECOND_SEASON_OPPORTUNITY_NOT_FOLLOWED_UP', // 未跟进商机
};

export const POTENTIAL_SECOND_SEASON = {
  POTENTIAL_SECOND_SEASON_UNKNOWN: 'POTENTIAL_SECOND_SEASON_UNKNOWN', // 商机未知原因
};

// 线索分层 筛选
export const LEAD_LAYER_TYPE = {
  'LEAD_LAYER_LA': 'LA',
  'LEAD_LAYER_SMB': 'SMB',
  'LEAD_LAYER_LA_UNRECOGNIZED': '未识别',
};

// 线索分发状态
export const LEAD_DISTRIBUTE_STATUS = {
  'NOT_DISTRIBUTE': '未分发',
  'ALREADY_DISTRIBUTE': '已分发',
  'DISTRIBUTING': '分发中',
};

// 推广经验
export const ADVERTISE_EXPERIENCE = {
  0: '无',
  1: '头条&抖音',
  2: '百度',
  3: '58',
  4: '美团&点评',
  5: '其他平台',
};

// 电商基建
export const BUSINESS_BASE = {
  0: '无',
  1: '京东',
  2: '淘宝&天猫',
  3: '抖音',
  4: '快手',
  5: '小程序',
  6: 'APP',
};

// 投放区域
export const DELIVERY_AREA = {
  0: '单城市',
  1: '多城市',
  2: '门店周边',
};

// 留资客户预算
export const BUDGET_TYPE = {
  1: '季度预算＜5000元',
  2: '5000元≤季度预算＜2万元',
  3: '2万元≤季度预算＜10万元',
  4: '季度预算≥10万元',
};
